module.exports = __webpack_public_path__ + "static/media/wow.1f61f9de.mp3";